module.exports = __webpack_public_path__ + "img/geofisica_3-4.5ea87460.webp";